import {
  Box,
  Button,
  Flex,
  Select,
  InputGroup,
  InputLeftElement,
  Input,
  Heading,
  Text,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  GridItem,
  Textarea,
} from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { FiMove as ApprovalIcon } from "react-icons/fi";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import apiCall from "../../../../utils/apiCall";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from "@chakra-ui/react";
import { useAtom, atom } from "jotai";
import {
  modalAtom,
  openAtom,
  notificationAtom,
  openNAtom,
} from "../,,/../../../../context";
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from "react-paginate";
import BatchMigration from "./Modal/BatchMigration";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
];

const HeadStyle = {
  borderBottom: "1px solid var(--dark-green-color)",
  padding: "15px 5px",
};
const DataStyle = {
  padding: "5px 5px",
  thcolor: "var(--dark-green-color)",
};

const ROWSTYLE = styled.tr`
  & > td:last-of-type {
    width: 50px;
    height: 63px;
    & > div {
      display: none;
    }
  }
  &:hover > * {
    cursor: pointer;
    background-color: var(--table-highlight);
  }
  & > td {
    width: 140px;
  }
  &:hover > td:last-of-type {
    & > div {
      display: block;
    }
  }
  & > td > div.active {
    display: block;
  }
`;

export default function StudentMigration() {
  const [hide, set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [selected_status, set_selected_status] = useState<null | string>(null);
  const queryClient = useQueryClient();
  const { data: applied_For_Induction_List, isLoading } = useQuery(
    ["applied-induction"],
    {
      queryFn: async () => {
        try {
          // Fetch first page
          const firstPageResponse = await apiCall().get(
            `/Exam/students/appliedForInduction/notMovedToMembership?PageNumber=1&PageSize=100`
          );
          let totalPages = firstPageResponse.data?.PageCount || 1;
          let allData = firstPageResponse.data?.reportItems || [];

          // Fetch remaining pages
          if (totalPages > 1) {
            const fetchPromises = [];
            for (let page = 2; page <= totalPages; page++) {
              fetchPromises.push(
                apiCall().get(
                  `/Exam/students/appliedForInduction/notMovedToMembership?PageNumber=${page}&PageSize=100`
                )
              );
            }

            const responses = await Promise.all(fetchPromises);
            responses.forEach((res) => {
              allData = [...allData, ...(res.data?.reportItems || [])];
            });
          }

          return allData;
        } catch (error) {
          console.error("Error fetching students:", error);
          return [];
        }
      },
      select: (data: any) => data, // Ensure all data is returned
    }
  );

  const [search, set_search] = useState("");

  const [filter_data, set_filter_data] = useState<any>(
    applied_For_Induction_List
  );

  const showBatchAproval = () => {
    set_modal({
      header: "Batch Migration",
      content: <BatchMigration />,
    });
    set_open(true);
  };

  const handleSearch = (e: any) => {
    let val = e.target.value;
    set_search(val);
    if (val) {
      let new_data = filter_data?.filter((eData: any) =>
        Object.values(eData).join("").toLowerCase().includes(val.toLowerCase())
      );
      if (new_data.length > 0) set_filter_data(new_data);
      else set_filter_data(applied_For_Induction_List);
    } else set_filter_data(applied_For_Induction_List);
  };

  /* Pagination part */
  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  /* End pagination part */

  useEffect(() => {
    if (selected_status) {
      let data = applied_For_Induction_List.filter(
        (eData: any) =>
          eData.Status.toLowerCase() === selected_status.toLowerCase()
      );
      if (data.length > 0) {
        set_filter_data(data);
      }
    } else {
      set_filter_data(applied_For_Induction_List);
    }
  }, [selected_status]);

  useEffect(() => {
    set_filter_data(applied_For_Induction_List);
  }, [applied_For_Induction_List]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Migrate Student To Membership"
            button_array={[
              <Button
                bg="var(--dark-green-color)"
                color="var(--white-color)"
                leftIcon={<ApprovalIcon />}
                variant="outline"
                colorScheme="var(--dark-green-color)"
                onClick={showBatchAproval}
              >
                Batch Migration
              </Button>,
              // <UploadButton label="Upload Candidates" />
            ]}
          />
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup
              h="40px"
              width="250px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
              pos="relative"
            >
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>
              <Input
                value={search}
                onChange={handleSearch}
                type="text"
                placeholder="search"
              />
              <span
                style={{
                  position: "absolute",
                  zIndex: "1",
                  right: "10px",
                  cursor: "pointer",
                  top: "12px",
                }}
              >
                <ReloadIcon />
              </span>
            </InputGroup>
            <Select
              placeholder="Status"
              width="130px"
              bg="var(--white-color)"
              borderColor="var(dark-green-color)"
              onChange={(e: any) => set_selected_status(e.target.value)}
            >
              <option>Applied For Induction</option>
              <option>Inducted</option>
            </Select>
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">
              All Applied For Induction Student
            </Heading>
            <Text m="0" fontSize=".8rem">
              Showing {itemOffset + 1} -{" "}
              {itemOffset + itemsPerPage > filter_data?.length
                ? filter_data?.length
                : endOffset}{" "}
              of {filter_data?.length}
            </Text>
          </Flex>
          {filter_data && filter_data.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th sx={HeadStyle}>S/N</Th>
                    <Th sx={HeadStyle}>Student No</Th>
                    <Th sx={HeadStyle}>First Name</Th>
                    <Th sx={HeadStyle}>Last Name</Th>
                    <Th sx={HeadStyle}>IsMoved</Th>
                    <Th sx={HeadStyle}>FinalMemberNo</Th>
                    <Th sx={HeadStyle}>IsOld</Th>
                    <Th sx={HeadStyle}>Status</Th>
                    <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((eCandidate: any, index: number) => (
                    <ROWSTYLE key={eCandidate.Id}>
                      <Td sx={DataStyle}>{eCandidate.SN}</Td>
                      <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                      <Td sx={DataStyle}>{eCandidate.FirstName}</Td>
                      <Td sx={DataStyle}>{eCandidate.LastName}</Td>
                      <Td sx={DataStyle}>
                        {eCandidate.IsMovedToMembership ? "Yes" : "No"}
                      </Td>
                      <Td sx={DataStyle}>
                        {eCandidate.FinalMembershipNo || "N/A"}
                      </Td>
                      <Td sx={DataStyle}>
                        {eCandidate.IsOldStudent ? "Yes" : "No"}
                      </Td>
                      <Td sx={DataStyle}>{eCandidate.Status}</Td>
                      <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                        <div className={activeIndex === index ? "active" : ""}>
                          <Option {...{ index, candidate: eCandidate }} />
                        </div>
                      </Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            "No Students"
          )}
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}

const StylePaginateBox = styled.div`
  width: 100%;
  & > ul {
    list-style-type: none;
    text-align: center;
    padding: 0;
    margin: 0;
    margin-top: 10px;
  }
  & > ul > li {
    display: inline;
    margin: 0 5px;
    padding: 2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color: var(--dark-green-color);
  }
  & > ul > li.selected {
    background-color: var(--highlight-paginate-background);
    color: var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type {
    font-weight: bold;
  }
`;

const sx = {
  ":hover": {
    bg: "var(--content-background)",
  },
};

const Option = (props: any) => {
  const index = props.index;
  const candidate = props.candidate;
  const [ind, set_index] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const onClick = () => {
    if (index === ind) {
      set_index(null);
      return;
    }
    set_index(index);
  };
  const handleShowProfile = () => {
    set_index(null);
    set_modal({
      header: "Student Details",
      content: <ViewProfile candidate={candidate} />,
    });
    set_open(true);
  };

  const handleSingleMigrate = () => {
    set_index(null);
    set_modal({
      header: "Migrate to Membership",
      content: <ViewSingleMigrate {...candidate} />,
    });
    set_open(true);
  };
  useEffect(() => {
    return () => set_index(null);
  }, []);
  return (
    <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)">
          <MoreIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>
              View Details
            </GridItem>
            {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
            <GridItem sx={sx} p="8px 4px" onClick={handleSingleMigrate}>
              Migrate Student
            </GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

const ViewProfile = (props: any) => {
  return (
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex align="center" gap="20px">
        {/* <Image
          src="/public-assets/profile.png"
          width="150px"
          height="150px"
          objectFit="contain"
          objectPosition="center"
          alt="profile"
        /> */}
        <Flex gap="20px">
          {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            Student NO
          </Text>
          <Text> {props.candidate.StudentNo}</Text>
        </Flex>
      </Flex>
      <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            First Name
          </Text>
          <Text fontWeight="500">
            {props.candidate.FirstName || "Osakpolo@gmail.com"}
          </Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            LastName
          </Text>
          <Text fontWeight="500">
            {props.candidate.LastName || "Not working"}
          </Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            Status
          </Text>
          <Text fontWeight="500">{props.candidate.Status || "Pending"}</Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};
const ViewSingleMigrate = (props: any) => {
  const [, set_open] = useAtom(openAtom);
  const [, set_n_open] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();
  const [Reason, set_reason] = useState(props?.Reason || "");

  const { isLoading: moveIsLoading, mutate: update_move_membership } =
    useMutation({
      mutationKey: ["move-to-membership"],
      mutationFn: async (studentNumbers: string) =>
        await apiCall().post(
          `/Exam/BatchMoveToMembership?studentNumbers=${studentNumbers}`,
          {}
        ),
      onSuccess(data: any) {
        //console.log(data,'data')
        set_notification({
          type: "success",
          message:
            data.data.Message || "Student Moved To Membership Successfully",
        });
        set_n_open(true);
        queryClient.invalidateQueries(["all-applied-induction"]);
      },
      onError(error: any) {
        set_notification({
          type: "error",
          message: error.data.Message || "Error Occured",
        });
        set_n_open(true);
      },
      onSettled() {
        set_open(false);
      },
    });

  return (
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex gap="10px" flexDir="column">
        <Flex gap="20px">
          <span>Student No:</span>
          <Text m="0" fontWeight="600">
            {props?.StudentNo}
          </Text>
        </Flex>
        <Flex gap="20px">
          <span>First Name:</span>
          <Text m="0" fontWeight="600">
            {props?.FirstName}
          </Text>
        </Flex>
        <Flex gap="40px">
          <span>Last Name:</span>
          <Text m="0" fontWeight="600">
            {props?.LastName}
          </Text>
        </Flex>
        <Flex gap="43px">
          <span>Status:</span>
          <Text m="0" fontWeight="600">
            {props?.Status}
          </Text>
        </Flex>
      </Flex>
      {/* <label>
          <Box fontWeight="500">Comment</Box>
          <Textarea placeholder="comment" resize="vertical" size="sm" value={Reason} 
          onChange={(e:any)=>set_reason(e.target.value)} 
          />
        </label> */}
      <Flex justify="center" gap="30px" align="center">
        <Button
          onClick={() => update_move_membership(props.StudentNo)}
          bg="var(--dark-green-color)"
          color="var(--white-color)"
          width="130px"
          disabled={moveIsLoading}
        >
          {moveIsLoading ? "Loading" : "Move"}
        </Button>
      </Flex>
    </Flex>
  );
};
